import React from 'react';
import { Tooltip as RechartsTooltip } from 'recharts';

export const ChartContainer = ({ children, config, className, ...props }) => (
  <div className={`w-full h-full ${className}`} {...props}>{children}</div>
);

export const ChartTooltip = ({ content, ...props }) => (
  <RechartsTooltip content={content} {...props} />
);

export const ChartTooltipContent = ({ content, hideLabel }) => (
  <div className="bg-white p-2 shadow rounded">
    {content.map((item, index) => (
      <div key={index} className="flex justify-between">
        {!hideLabel && <span className="font-bold mr-2">{item.label}:</span>}
        <span>{item.value}</span>
      </div>
    ))}
  </div>
);
